"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closeSsoOnConfirm;

var _empty = require("rxjs/observable/empty");

var _of = require("rxjs/observable/of");

var _mergeMap = require("rxjs/operators/mergeMap");

var _Modals = _interopRequireDefault(require("../constants/Modals"));

var _selectors = require("../selectors");

var _AccountDefaultsActions = require("../actions/AccountDefaultsActions");

var _actions = require("settings-ui-sdk/SingleSignOn/actions");

function closeSsoOnConfirm($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.ConfirmSamlSettingsActionTypes.SUCCESS).pipe((0, _mergeMap.mergeMap)(function () {
    if ((0, _selectors.getOpenModal)(getState()) === _Modals.default.EDIT_SSO) {
      return (0, _of.of)((0, _AccountDefaultsActions.closeModal)());
    }

    return (0, _empty.empty)();
  }));
}

module.exports = exports.default;